<template>
  <!-- navbar area end -->
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>-->

  <appheader></appheader>
  <router-view />
<appfooter></appfooter>
</template>
<script>
import appheader from '@/components/appheader.vue'
import appfooter from '@/components/appfootervue.vue';
export default {
  components: { appfooter,appheader },
  methods: {
    goTo(url) {
      location.href = url;
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
